import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Http, RequestOptions } from "@angular/http";
import { RouterModule } from "@angular/router";
import { AuthConfig, AuthHttp } from "angular2-jwt";
import { NgxCaptchaModule } from "ngx-captcha";
import { AuthGuard } from "./auth.guard";
import { AuthService } from "./auth.service";
import { FilterHttp } from "./filter-http";
import { LoginFormComponent } from "./login-form/login-form.component";
import { LogoutService } from "./logout.service";
import { DialogModule } from "primeng/dialog";
import { InputTextModule } from "primeng/inputtext";
import { AuditoriaContextService } from "../core/services/auditoria/auditoria-context.service";

import { SharedsModule } from '../shareds/shareds.module';

export function authHttpServiceFactory(
  auth: AuthService,
  auditoriaContextService: AuditoriaContextService,
  http: Http,
  options: RequestOptions
) {
  const config = new AuthConfig({
    globalHeaders: [{ "Content-Type": "application/json" }]
  });

  return new FilterHttp(auth, auditoriaContextService, config, http, options);
}

@NgModule({
  imports: [
    SharedsModule,
    CommonModule, 
    FormsModule, 
    RouterModule, 
    NgxCaptchaModule,
    DialogModule,
    InputTextModule,

  ],
  declarations: [
    LoginFormComponent
  ],
  providers: [
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [AuthService, AuditoriaContextService, Http, RequestOptions]
    },
    AuditoriaContextService,
    AuthGuard,
    LogoutService
  ]
})
export class SegurancaModule {}
